function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.169 17.815c.169 1.098.76 2.111 1.689 2.871l14.269 10.385a4.394 4.394 0 006.079-.844L40.275 6.924c1.435-1.858 1.098-4.559-.844-5.995s-4.644-1.098-6.164.844L17.9 21.615 7.177 13.763c-1.942-1.435-4.644-1.013-6.164.844-.76.929-1.013 2.111-.844 3.208z"
});

function SvgCheckmarkChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 32"
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 41 32'%3E %3Cpath d='M0.169 17.815c0.169 1.098 0.76 2.111 1.689 2.871l14.269 10.385c1.942 1.435 4.644 1.013 6.079-0.844l18.069-23.303c1.435-1.858 1.098-4.559-0.844-5.995s-4.644-1.098-6.164 0.844l-15.367 19.842-10.723-7.852c-1.942-1.435-4.644-1.013-6.164 0.844-0.76 0.929-1.013 2.111-0.844 3.208z' /%3E %3C/svg%3E";
export { SvgCheckmarkChecked as ReactComponent };